import React, { useEffect, useState } from "react";
import { Trans } from "@lingui/macro";
import { Loader } from "components/UI/Loader/Loader";
import { CallbackListItem } from "./CallbackListItem";
import { useDispatch, useSelector } from "react-redux";
import { typeSettingsState } from "model/dashboardSettings/settingsReducer";
import { settingsSetCallbackDataSagaAC } from "model/dashboardSettings/settingsActionCreators";

// Types

export type typeCallbackObjItem = {
  id: string | undefined;
  url: string;
};

export type typeCallbackObj = {
  empty: boolean;
  ORDER: typeCallbackObjItem | null;
  SALE: typeCallbackObjItem | null;
  REFUND: typeCallbackObjItem | null;
  Z_REPORT: typeCallbackObjItem | null;
};

// Component
export const CallbackList: React.FC = () => {
  const dispatch = useDispatch();
  const callbackLoader = useSelector(
    (state: { settings: typeSettingsState }) => state.settings.callbackLoader,
  );
  const callbackDataList = useSelector(
    (state: { settings: typeSettingsState }) => state.settings.callbackData,
  );

  const [callbacksObject, setCallbackObject] = useState<typeCallbackObj>({
    empty: !!callbackDataList.length,
    ORDER: null,
    SALE: null,
    REFUND: null,
    Z_REPORT: null,
  });

  useEffect(() => {
    dispatch(settingsSetCallbackDataSagaAC());
  }, [dispatch]);

  useEffect(() => {
    const newCallbackObject = callbacksObject;

    newCallbackObject.empty = !callbackDataList.length;

    const orderCompletion = callbackDataList.find(
      (item) => item.eventType === "ORDER",
    );
    if (orderCompletion)
      newCallbackObject.ORDER = {
        id: orderCompletion.id,
        url: orderCompletion.url,
      };
    else newCallbackObject.ORDER = null;

    const sale = callbackDataList.find((item) => item.eventType === "SALE");
    if (sale) newCallbackObject.SALE = { id: sale.id, url: sale.url };
    else newCallbackObject.SALE = null;

    const refund = callbackDataList.find((item) => item.eventType === "REFUND");
    if (refund) newCallbackObject.REFUND = { id: refund.id, url: refund.url };
    else newCallbackObject.REFUND = null;

    const zReport = callbackDataList.find(
      (item) => item.eventType === "Z_REPORT",
    );
    if (zReport)
      newCallbackObject.Z_REPORT = { id: zReport.id, url: zReport.url };
    else newCallbackObject.Z_REPORT = null;

    setCallbackObject(newCallbackObject);

    // eslint-disable-next-line
  }, [callbackDataList]);

  return (
    <div className="md:col-span-2 relative flex flex-col gap-2">
      <div className="flex gap-4 justify-between items-center">
        <div className="text-lg font-medium text-gray-500">
          <Trans>Callbacks</Trans>:
        </div>
      </div>
      <div className="relative flex-grow">
        <div className="border rounded flex flex-col divide-y">
          <CallbackListItem
            id={callbacksObject.ORDER ? callbacksObject.ORDER.id : null}
            url={callbacksObject.ORDER ? callbacksObject.ORDER?.url : null}
            callbackType="ORDER"
          />
          <CallbackListItem
            id={callbacksObject.SALE ? callbacksObject.SALE.id : null}
            url={callbacksObject.SALE ? callbacksObject.SALE.url : null}
            callbackType="SALE"
          />
          <CallbackListItem
            id={callbacksObject.REFUND ? callbacksObject.REFUND.id : null}
            url={callbacksObject.REFUND ? callbacksObject.REFUND.url : null}
            callbackType="REFUND"
          />

          <CallbackListItem
            callbackType="Z_REPORT"
            id={callbacksObject.Z_REPORT ? callbacksObject.Z_REPORT.id : null}
            url={callbacksObject.Z_REPORT ? callbacksObject.Z_REPORT.url : null}
          />
        </div>
      </div>

      {callbackLoader ? <Loader /> : null}
    </div>
  );
};
